module.exports = __webpack_public_path__ + "static/img/rongzi-btn.d4c772f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/platformIntroduce/rongzi-btn.png
// module id = 1K1b
// module chunks = 70